// extracted by mini-css-extract-plugin
module.exports = {"break":"Break_break__T5tfU"};